import React, { useState, useEffect } from 'react'
import { Container, Button, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Axios from 'axios';



export default function Home(props) {

  const [isAuth, setIsAuth] = useState(false);
  const [zenQuote, setZenQuote] = useState({});

  
  useEffect(() => {  
    zenQuotes()
}, [])

  const imagesHome = [
    "buddha-g0e0d9479d_1280.jpg",
    "buddha-g19af6d816_1280.jpg",
    "buddha-gda9d5efb5_1280.jpg",
    "stones-ga6eb43251_1920.jpg",
    "zen-g0741174c8_1280.jpg",
    "zen-geee477e23_1280.jpg"
  ]

  const getImage = () => {
    const imagesPath = "/images/";
    const maxImages = imagesHome.length - 1;
    let index = Math.random() * maxImages;
    return imagesPath + imagesHome[Math.trunc(index)];
  }

  const zenQuotes = () => {
    Axios.get(`https://zenquotes.io/api/quotes/ramdon`)
    .then(response => {
        console.log("Loaded Quotes!")
        console.log(response.data) 
        setZenQuote({quote: response.data[0].q, author: response.data[0].a});
          
    })
    .catch(error => {
        console.log("Error Loading Quotes")
    })
}

  return (
     <div className="bg" style={{ width: "100%", height: "100vh"}}>
      <div className="bg-img" style={{ backgroundImage: `url(${getImage()})`, backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center", width: "100%", height: "100%"}}></div>
      <Container className="homepage">
        <img id="logo-home" src="/zen-brush-symbol.png" alt="Zen circle"></img>
        <h1 id="h1-home">Zen Journal</h1>
        <h3 id="slogan-home">A clean and simple app to time and track meditations</h3>
        <h2 id="h2-home">{zenQuote.quote} - {zenQuote.author}</h2>

                { props.isAuth ? (
                  <>
                  <Col className="home-button" xs={6}><Button xs={2} variant="danger"><Link style={{ color: "white" }} to="/meditation/index">Go to meditations</Link></Button></Col>
                  </>
                ) : (
                  <>
                  <Col className="home-button" xs={6}><Button xs={2} variant="danger"><Link style={{ color: "white" }} to="/signup">Create an account</Link></Button></Col>
                  </>
                )} 
                

                {/* <Col className="quote" xs={10} md={8}>{zenQuote.quote} - {zenQuote.author}</Col> */}
      </Container>
    
    </div>
  )
}
